:host {
    font: inherit;

    .wine-scale {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 32px;

        @media screen and (min-width: 1024px) {
            justify-content: flex-start;
            gap: 16px;
        }

        .wine-scale-entries {
            display: flex;
            width: 100%;
            flex-flow: row wrap;
            gap: 32px;

            @media screen and (min-width: 1024px) {
                flex-flow: unset;
            }
        }

        .wine-scale-entry {
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            @media screen and (min-width: 1024px) {
                height: 80px;
                justify-content: space-between;
            }
        }

        .wine-scale-entries-1 {
            .wine-scale-entry {
                justify-content: flex-start;
            }
        }

        .wine-scale-entries-2 {
            width: 100%;
            display: flex;
            flex-flow: row wrap;
            gap: 32px;
            margin-bottom: 28px;
            justify-content: space-between;

            @media screen and (min-width: 1024px) {
                padding: 8px 0;
                gap: 0;
                margin: 0;
            }
        }

        .wine-scale-entries-1, .wine-scale-entries-2 {
            @media screen and (min-width: 1024px) {
                width: 50%;
            }
        }

        .wine-scale-entry-label,
        label {
            font-size: var(--vx-tabs-content-font-size--mobile, 1rem);

            @media screen and (min-width: 1024px) {
                font-size: var(--vx-tabs-content-font-size--mobile, 1rem);
            }
        }

        .wine-scale-entry-value {
            span {
                margin-left: 0.6rem;
                padding: 8px;
                border-radius: 8px;
                border: 1px solid #ddd;
                font-size: 0.8rem;

                @media screen and (min-width: 1024px) {
                    font-size: var(--vx-tabs-content-font-size--mobile, 1rem);
                    padding: 10px;
                    margin-left: 1rem;
                }
            }
        }

        .wine-scale-sliders {
            display: flex;
            width: 100%;
            flex-flow: row wrap;
            gap: 24px;

            @media screen and (min-width: 1024px) {
                flex-flow: unset;
            }
        }

        .slider-container {
            position: relative;
            width: 100%;

            @media screen and (min-width: 1024px) {
                min-height: 80px;
                margin-bottom: 5px;
            }

            .scale-wrapper {
                display: flex;
                flex-direction: row;
                margin-top: 24px;

                @media screen and (min-width: 1024px) {
                    margin-top: 16px;
                }

                .scale-inner-wrapper {
                    position: relative;
                    display: flex;
                    width: 100%;

                    @media screen and (min-width: 1024px) {
                        margin: 0 44px;
                    }
                }
            }

            label {
                background: #fff;
                padding: 0 10px 0 0;
                margin-bottom: 16px;
                box-sizing: border-box;
            }

            .scale-label {
                font-size: 0.7rem;
                color: #666;
                width: 35%;

                @media screen and (min-width: 1024px) {
                    width: 15%;
                    font-size: 0.8rem;
                }

                &.right {
                    text-align: right;
                }
            }

            input[type="range"] {
                appearance: none;
                height: 2px;
                background: #ddd;
                outline: none;
                opacity: 0.7;
                width: 100%;
                margin: auto 0;

                &::-webkit-slider-thumb {
                    appearance: none;
                }

                &::-moz-range-thumb {
                    appearance: none;
                }
            }

            .value {
                box-sizing: border-box;
                position: absolute;
                border: 1px solid #ddd;
                background-color: white;
                border-radius: 8px;
                width: 60px;
                margin-left: -30px;
                height: 34px;
                margin-top: -17px;
                display: flex;
                align-items: center;
                justify-content: center;
                top: 50%;
                font-size: 0.8rem;

                @media screen and (min-width: 1024px) {
                    width: 84px;
                    margin-left: -44px;
                    height: 44px;
                    margin-top: -22px;
                    font-size: var(--vx-tabs-content-font-size--mobile, 1rem);
                }
            }
        }
    }

    vx-popover {
        position: absolute;
        background-color: white;
        z-index: 99;
        top: 30px;
        max-width: 70vw;
    }

    .info-circle {
        justify-self: flex-start;
        height: 16px;
        width: 16px;

        border: 1px solid var(--wf-wine-scale-grey, #908787);
        border-radius: 50%;

        cursor: pointer;
        display: inline-flex;
        justify-content: center;
        align-items: center;

        margin: auto 0;

        .info-icon {
            font-size: 14px;
            color: var(--wf-wine-scale-grey, #908787);
        }
    }

    .info-tooltip {
        display: grid;
        grid-column: 1 / 4;

        grid-template-rows: auto auto auto;
        grid-template-columns: 1fr 1fr;

        &-headline {
            grid-row: 1 / 2;
            grid-column: 1 / 3;
            font-size: var(--vx-tabs-content-font-size--mobile, 1rem);
            margin-top: 0;
        }

        &-text {
            grid-row: 2 / 3;
            grid-column: 1 / 3;
            font-size: var(--vx-wine-scale-info-card-font-size, .875rem);
            line-height: var(--vx-wine-scale-info-card-line-height, 1.125rem);
            font-weight: var(--vx-wine-scale-info-card-font-weight, 400);

            a {
                color: var(--vx-wine-scale-info-card-link-color, #000);
                text-decoration: underline;

                &:hover {
                    color: var(--vx-wine-scale-info-card-link-hover-color, #ea5659);
                }
            }
        }
    }
}
